__turbopack_context__.v({
  "amount": "styles-module-scss-module__F00F_G__amount",
  "animate": "styles-module-scss-module__F00F_G__animate",
  "button": "styles-module-scss-module__F00F_G__button",
  "hide": "styles-module-scss-module__F00F_G__hide",
  "root": "styles-module-scss-module__F00F_G__root",
  "showButton": "styles-module-scss-module__F00F_G__showButton",
});
